import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { IonTextarea, ModalController, NavParams } from '@ionic/angular';
import { GroupbuyItemComment } from '@mommy/models/groupbuy.model';
import { UtilService } from '@mommy/services/util.service';
import { DoGBIItemComment } from '@mommy/state/vender/vender-gb/vender-gb.actions';
import { Store } from '@ngxs/store';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-gb-comment-modal',
  templateUrl: './edit-gb-comment-modal.page.html',
  styleUrls: ['./edit-gb-comment-modal.page.scss'],
})
export class EditGBCommentModalPage implements OnInit, AfterViewInit {
  @ViewChild('commentInput') commentInput: IonTextarea;

  comment = '';
  groupbuy_instance_id = 0;
  item_name = '';
  score = 0; //1~5
  item_comment_id = 0;

  editType;
  _commentObj;

  constructor(
    public modalController: ModalController,
    public navParams: NavParams,
    private store: Store,
    private util: UtilService
  ) {
    this._commentObj = navParams.get('comment');
    console.log('_commentObj', this._commentObj);

    this.groupbuy_instance_id = this.navParams.get('groupbuy_instance_id');
    this.item_name = this.navParams.get('item_name');
    this.editType = navParams.get('editType');
  }

  ngOnInit() {
    if (this.editType === 'edit') {
      const _comment = _.cloneDeep(this._commentObj);
      this.item_comment_id = _comment.item_comment_id;
      this.comment = _comment.comment;
      this.score = _comment.score;
    }
  }

  ngAfterViewInit() {
    console.log('ngAfterViewInit this.commentInput:', this.commentInput);

    setTimeout(() => {
      for (let i = 0; i < 10; i++) {
        setTimeout(() => {
          this.commentInput.setFocus();
        }, 100 * i);
      }
    }, 100);
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  onRate(event) {
    console.log('onRate', event);
    this.score = event;
  }

  async submit() {
    console.log('submit comment');

    if (this.editType === 'edit') {
      // 修改評論
      try {
        const data: GroupbuyItemComment = {};
        data.item_comment_id = this.item_comment_id;
        data.groupbuy_instance_id = this.groupbuy_instance_id;
        data.comment = this.comment;
        data.item_name = this.item_name;
        data.score = this.score;

        await this.store.dispatch(new DoGBIItemComment(data)).toPromise();
        console.log('DoGBIItemComment success');
      } catch (error) {
        console.error('DoGBIItemComment error', error);
        this.util.showToast('發生錯誤');
        return;
      }
    } else {
      // 新增評論
      try {
        const data: GroupbuyItemComment = {};
        data.groupbuy_instance_id = this.groupbuy_instance_id;
        data.comment = this.comment;
        data.item_name = this.item_name;
        data.score = this.score;

        console.log('DoGBIItemComment data', data);

        await this.store.dispatch(new DoGBIItemComment(data)).toPromise();
        console.log('DoGBIItemComment success');
      } catch (error) {
        console.error('DoGBIItemComment error', error);
        this.util.showToast('發生錯誤');
        return;
      }
    }

    this.modalController.dismiss({
      comment: this.comment,
      refresh: true,
    });
  }
}
